// extracted by mini-css-extract-plugin
export var avatar = "_rj-3";
export var avatarContainer = "_rj-2";
export var avatarSpacer = "_rj-5";
export var avatarSpacerContainer = "_rj-4";
export var avatarStackContainer = "_rj-1";
export var bubble = "_rj-0";
export var remainderBubble = "_rj-6";